import styled, { css } from 'styled-components'

export const Table = styled.table`
  width: 100%;
  border: 1px solid #E0E0E0;
  border-collapse: collapse;
`

export const TableHead = styled.thead`
  tr {
    th {
      box-sizing: border-box;
      ${props => props.theme.header}
    }
  }
`
export const TableBody = styled.tbody`
  tr {
    td {
      box-sizing: border-box;
      ${props => props.theme.motion}
      ${props => props.theme.default}
    }
    &:nth-child(2n+1){
      td{
        ${props => props.theme.striped}
      }
    }
    &:hover{
      td {
        ${props => props.theme.states.hover}
      }
    }
  }
`
interface TableRowProps {
  Deleted?: boolean;
}

export const TableRow = styled.tr<TableRowProps>`

  text-decoration: ${props => props.Deleted ? 'line-through' : 'none'};
  min-height: '40px';
`

export const TableFoot = styled.div`
display: flex;
justify-content: flex-end;
align-items: center;

padding-top: 10px;
padding-bottom: 10px;
border-bottom: 1px solid #E0E0E0;
border-left: 1px solid #E0E0E0;
border-right: 1px solid #E0E0E0;
padding-right: 10px;
`

// Mobile Styled Components
export const Wrapper = styled.div`
`

export const Collapsable = styled.div`
  ${props => props.theme.collapsable}
  &:nth-child(even){
    ${props => props.theme.striped}
  }
  &:hover{
    ${props => props.theme.states.hover}
  }
`

interface AccordionTableProps {
  opened: boolean
}

export const AccordionTable = styled.div<AccordionTableProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${props => props.theme.accordionTable}
  ${props => css`
    > .tmp-icon {
      .chevron__container{
        ${props.theme.motion}
        transition-property: transform;
      }
      .chevron__line1,
      .chevron__line2{
        ${props.theme.motion}
        stroke-width: 10;
        stroke-linecap: round;
        stroke: currentColor;
        transform-origin: 50px 50px;
      }
    }
  ` }
  ${props => !props.opened ? css`
    > .tmp-icon {
      .chevron__container{
        transform: translateY(13px);
      }
      .chevron__line1 {
        transform: rotate(40deg);
      }
      .chevron__line2 {
        transform: rotate(-40deg);
      }
    }
  ` : css`
    > .tmp-icon {
      .chevron__container{
        transform: translateY(-13px);
      }
      .chevron__line1 {
        transform: rotate(-40deg);
      }
      .chevron__line2 {
        transform: rotate(40deg);
      }
    }
  `}
`

export const AccordionTableLabel = styled.div`

`

interface ContentAccordionTableProps {
  opened: boolean
}


export const ContentAccordionTable = styled.div<ContentAccordionTableProps>`
  display: block;
  max-height: 0;
  overflow: hidden;
  ${props => props.theme.motion}
  transition-property: max-height;
  ${props => props.opened && css`
    max-height: 10000px;
  `}
`


export const ContentRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${props => props.theme.accordionTable}
  ${props => props.theme.contentRow}
`

export const ContentLabel = styled.div`
  ${props => props.theme.contentLabel}
`

export const ContentData = styled.div`
  ${props => props.theme.contentData}
`
export const LabelPagination = styled.span`
    font-size: 18px;
    padding-left: 10px;
    padding-right: 10px;
    font-weight: 500;
    font-family: Inter, sans-serif;
    margin: 0px;
    line-height: 32px;
`
